import { OverlayRef } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { AuthService, LoyaltyLoginCoreService, NavigationService } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';

import { MessageData } from './betstation-login.models';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TrustAsHtmlPipe],
    selector: 'vn-betstation-active-session-info-overlay',
    templateUrl: './betstation-active-session-info-overlay.component.html',
})
export class BetstationActiveSessionInfoOverlayComponent {
    readonly messageData = input.required<MessageData>();

    private readonly authService = inject(AuthService);
    private readonly navigationService = inject(NavigationService);
    private readonly loyaltyLoginCoreService = inject(LoyaltyLoginCoreService);
    private readonly overlayRef = inject(OverlayRef);

    ok() {
        if (this.loyaltyLoginCoreService.loyaltyValidation) {
            this.overlayRef.detach();
        } else {
            this.authService
                .logout({ redirectAfterLogout: false, isAutoLogout: true })
                .catch(() => this.navigationService.goToLastKnownProduct({ forceReload: true }));
        }
    }
}
